import React from 'react';
import { NavLink } from 'react-router-dom';
import { Route } from 'react-router-dom';

// Project //
import HTML from './Project/HTML';
import CSS from './Project/CSS'
import JavaScript from './Project/JavaScript'

const Projects = () => (
    <div className="project-container">
        <div className="title-and-nav">
            <h2 className="project-title">Projects</h2> 
            <div className="projects-nav">
                <NavLink className="project-nav-link" to="/projects/html">HTML</NavLink>
                <NavLink className="project-nav-link" to="/projects/css">CSS</NavLink>
                <NavLink className="project-nav-link" to="/projects/javascript">JavaScript</NavLink>
            </div>
        </div>
    
        {/* Write routes here... */}
        <Route path="/projects/html" component={HTML} />
        <Route path="/projects/css" component={CSS} />
        <Route path="/projects/javascript" component={JavaScript} />
    </div>
);

export default Projects;